export default {
    IS_NOT_EMPTY: 'There is a missing data',
    IS_EMAIL: 'Email not valid',
    MIN_LENGTH_6: 'Minimum 6 characters',
    MIN_LENGTH_3: 'Enter minimum 3 characters',
    IS_MOBILE_PHONE: 'Phone number is not valid',
    CONTAINS_facebook: 'Facebook url is not valid',
    CONTAINS_instagram: 'Instagram url is not valid',
    CONTAINS_linkedin: 'LinkedIn url is not valid',
    CONTAINS_twitter: 'X-Twitter url is not valid',
    CONTAINS_tiktok: 'Tik Tok url is not valid',
    CONTAINS_review: 'Google url is not valid',
    IS_NUMBER_STRING: 'Invalid value',
    INVALID_PIB: 'PIB is not valid',
    IS_POSITIVE: 'Number must be positive',
    IS_DATE_STRING: 'Invalid format',
    IS_PHONE_NUMBER: 'Phone number in format with country code (+38164123123)',
    MAXIMUM_100: 'You have exceeded the allowed number of characters of 100',
    MAXIMUM_255: 'You have exceeded the allowed number of characters of 255',
    MAXIMUM_600: 'You have exceeded the allowed number of characters of 600',
    MAXIMUM_1: 'Number must be between 1 - 100',
    MINIMUM_0: 'Number must be greater than 0',
    MINIMUM_15: 'Number must be greater than 15',
    MAXIMUM_180: 'Number must be lett than 180',
    IS_ARRAY: 'You need to choose at least on option',
    OFFER: {
        EXPIRED: 'This service has expired.',
        NOT_FOUND: 'This service not found.',
    },
    DISCOUNT: {
        ALREADY_ACTIVE_DISCOUNT_FOR_OFFER_CATEGORY: 'Category already has discount for this time range',
    },
    CATEGORY: {
        CATEGORY_NOT_FOUND: 'Category is deleted!',
    },
    AVAILABILITY: {
        TO_IS_SAME_OR_BEFORE_FROM: `'To date' must be after the 'From date'.`,
        DIFFERENT_TIMEZONE: `This availability is in different timezone. Please create new availability`,
    },
    LOCATION: {
        DIFFERENT_TIMEZONE: `Change location address is available only in the same timezone.`,
    },
    USER: {
        TAKEN_EMAIL: 'This email address is already taken',
        EMAIL_BAD_FORMAT: 'Email not valid',
        EMAIL_NOT_VERIFIED: 'Please confirm your email first',
        BAD_CREDENTIALS: 'Credentials not valid',
        INVALID_OLD_PASSWORD: 'Password not valid',
        RESEND_LIMIT_REACHED: 'Resend sms limit reached',
        INVALID_CHANGE_MOBILE_TOKEN: 'Verification code is invalid',
        ALREADY_PART_OF_THE_COMPANY: 'A client already exists in the company!',
        HAS_ACTIVE_COMPANY: 'It is not possible to delete a profile with an active company.',
    },
    COMPANY: {
        NAME_EXIST: 'Company name already exists',
        PIB_EXIST: 'PIB already exists',
        SUBDOMAIN_NOT_ALLOWED: 'Subdomain name not valid!',
        SUBDOMAIN_EXISTS: 'Subdomain name already exists',
    },
    RATING: {
        ALREADY_RATED: 'Service is already rated',
        TOKEN_EXPIRED: 'Time for rating has expired!',
    },
}
